'use client';

import { useEffect } from 'react';

import { show } from '@intercom/messenger-js-sdk';

import { selectContentDataLayerEvent } from '@/modules/product/services/data-layer-events/select_content';

export default function ContactUsPageTemplate() {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    // Track that the Contact Us page was accessed directly
    selectContentDataLayerEvent({
      contentType: 'Contact',
      name: 'Contact Us Page Direct Access',
    });

    const intervalId = setInterval(() => {
      const intercomFrame = document.querySelector('iframe[id="intercom-frame"]');

      if (intercomFrame) {
        show();
        clearInterval(intervalId);
      }
    }, 500);

    const timeoutId = setTimeout(() => clearInterval(intervalId), 10000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="container my-10">
      <h1 className="text-center text-6xl font-bold">Contact Us</h1>

      <p className="mb-4 mt-4 block text-center text-2xl">
        Have a question or comment? Our team will be happy to hear from you.
      </p>
      <p className="mx-auto mb-20 mt-4 block max-w-[750px] text-center text-2xl">
        Please email us at{' '}
        <a className="underline" href="mailto:support@designshop.com">
          support@designshop.com
        </a>{' '}
        and a member of our support team will be in touch as soon as possible.
      </p>
    </div>
  );
}
